import { render } from "./MnemonicInput.vue?vue&type=template&id=11127a21&scoped=true"
import script from "./MnemonicInput.vue?vue&type=script&lang=js"
export * from "./MnemonicInput.vue?vue&type=script&lang=js"

import "./MnemonicInput.vue?vue&type=style&index=0&id=11127a21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11127a21"]])

export default __exports__